import {
  Box, CardBody, CardFooter, CardHeader, FormControl, FormErrorMessage,
  FormLabel, Skeleton, Textarea, VStack
} from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import { useFetchKuchikomyuSetting } from "../../../hooks/kuchikomyu/useFetchKuchikomyuSetting";
import { useEditKuchikomyuSettingFormForAdmin } from "../../../hooks/kuchikomyu/useEditKuchikomyuSettingFormForAdmin";
import { Controller } from "react-hook-form";
import { ReactSelectWithChakraStyle } from "../../atoms/ReactSelectWithChakraStyle";
import { SubmitBtn } from "../../atoms/button/SubmitBtn";
import { useEditKuchikomyuSettingByAdmin } from "../../../hooks/kuchikomyu/useEditKuchikomyuSettingByAdmin";
import { DarkShadowCard } from "../../molecules/card/DarkShadowCard";
import { CardHeading } from "../../molecules/card/CardHeading";
import { SettingsIcon } from "@chakra-ui/icons";
import { SelectOption } from "../../../types/select";
import { useEffect } from "react";

export const EditKuchikomyuSettingByAdmin = () => {
  const { settingsId } = useParams<{ settingsId: string }>();

  const { kuchikomyuSetting, isLoading } = useFetchKuchikomyuSetting(settingsId);

  // ✅ hookは必ずコンポーネント先頭で呼ぶ（初期値を fallback にしておく）
  const formInitValues = kuchikomyuSetting ?? { branch_score: 0, g_url: "", en_url: "" };

  const {
    handleSubmit,
    register,
    control,
    formState: { isSubmitting, errors },
    reset // ← reset を取得
  } = useEditKuchikomyuSettingFormForAdmin({ branch_score: 0, g_url: "", en_url: "",default_url:"",default_en_url:"" });

  useEffect(() => {
    if (kuchikomyuSetting) {
      reset({
        branch_score: kuchikomyuSetting.branch_score.toString(),
        g_url: kuchikomyuSetting.g_url,
        en_url: kuchikomyuSetting.en_url,
        default_url: kuchikomyuSetting.default_url,
        default_en_url: kuchikomyuSetting.default_en_url,
      });
    }
  }, [kuchikomyuSetting, reset]);

  const onSubmit = useEditKuchikomyuSettingByAdmin(settingsId);

  const options: SelectOption[] = [
    { value: "1", label: "1" },
    { value: "2", label: "2" },
    { value: "3", label: "3" },
    { value: "4", label: "4" },
    { value: "5", label: "5" },
  ];

  const branchScoreError = errors.branch_score?.message;
  const gUrlError = errors.g_url?.message;
  const enUrlError = errors.en_url?.message;

  if (!settingsId || isLoading || !kuchikomyuSetting) {
    return (
        <Box m='auto' w={{ base: '100%', md: '700px' }}>
          <DarkShadowCard>
            <CardHeader>
              <CardHeading icon={<SettingsIcon />} heading='口コミュ設定' />
            </CardHeader>
            <CardBody py={2}>
              <VStack spacing={5}>
                <Skeleton height="40px" w="100%" />
                <Skeleton height="40px" w="100%" />
              </VStack>
            </CardBody>
          </DarkShadowCard>
        </Box>
    );
  }

  return (
      <Box m='auto' w={{ base: '100%', md: '700px' }}>
        <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
          <DarkShadowCard>
            <CardHeader>
              <CardHeading icon={<SettingsIcon />} heading='口コミュ設定' />
            </CardHeader>
            <CardBody py={2}>
              <VStack spacing={5}>
                <FormControl isRequired isInvalid={!!errors.branch_score} w='100%'>
                  <FormLabel>ブランチスコア</FormLabel>
                  <Controller
                      name='branch_score'
                      control={control}
                      render={({ field }) => (
                          <ReactSelectWithChakraStyle
                              placeholder="選択"
                              options={options}
                              value={options.find(option => option.value === field.value)}
                              onChange={(option: SelectOption | null) => field.onChange(option?.value)}
                          />
                      )}
                  />
                  <FormErrorMessage>{branchScoreError}</FormErrorMessage>
                </FormControl>
                <FormControl isRequired isInvalid={!!errors.g_url} w='100%'>
                  <FormLabel>URL①</FormLabel>
                  <Textarea {...register('g_url')} />
                  <FormErrorMessage>{gUrlError}</FormErrorMessage>
                </FormControl>
                <FormControl isRequired isInvalid={!!errors.en_url} w='100%'>
                  <FormLabel>英語版URL①</FormLabel>
                  <Textarea {...register('en_url')} />
                  <FormErrorMessage>{enUrlError}</FormErrorMessage>
                </FormControl>
                <FormControl isInvalid={!!errors.default_url} w='100%'>
                  <FormLabel>URL②</FormLabel>
                  <Textarea {...register('default_url')} />
                  <FormErrorMessage>{gUrlError}</FormErrorMessage>
                </FormControl>
                <FormControl isInvalid={!!errors.default_en_url} w='100%'>
                  <FormLabel>英語版URL②</FormLabel>
                  <Textarea {...register('default_en_url')} />
                  <FormErrorMessage>{enUrlError}</FormErrorMessage>
                </FormControl>
              </VStack>
            </CardBody>
            <CardFooter>
              <SubmitBtn isLoading={isSubmitting}>登録</SubmitBtn>
            </CardFooter>
          </DarkShadowCard>
        </form>
      </Box>
  );
};